// extracted by mini-css-extract-plugin
export default {"root":"_eN8_","scrollContainer":"PLfIt","themed":"LZ2jE","onShader":"zWngZ","light":"CNCBh"};